module.exports = __webpack_public_path__ + "img/CECA_TMKI67.e74b48b0.png";